import { combineReducers } from "redux"
import optionDataReducer from "./optionDataReducer";


const rootReducer = combineReducers({
    optionData: optionDataReducer
})

export default rootReducer